import { ModalErrorConfig } from '@core/interfaces/modal-error-config.interface';
import { PROJECT_TYPE } from '@core/types/projects.type';

export const ACCOUNT_OPENED_CONFIG = new Map<PROJECT_TYPE, ModalErrorConfig>([
  [
    'ACC',
    {
      imageUrl: {
        url: 'assets/img/errors/error__info-not-loaded.svg',
        altUrl: 'Information not loaded icon/illustration',
      },
      errorTitle: '¡Oh, no!',
      errorDescription:
        'Hubo un error y no pudimos abrir tu cuenta. Por tu seguridad, volveremos al inicio.',
      buttonLabel: 'Volver al inicio',
    },
  ],
  [
    'SHELL',
    {
      imageUrl: {
        url: 'assets/img/errors/error__info-not-loaded.svg',
        altUrl: 'Information not loaded icon/illustration',
      },
      errorTitle: '¡Oh, no!',
      errorDescription:
        'Hubo un error y no pudimos continuar. Por tu seguridad, volveremos al inicio.',
      buttonLabel: 'Volver al inicio',
    },
  ],
  [
    'PLD',
    {
      imageUrl: {
        url: 'assets/img/errors/error__info-not-loaded.svg',
        altUrl: 'Information not loaded icon/illustration',
      },
      errorTitle: '¡Oh, no!',
      errorDescription:
        '¡Hubo un error! No pudimos ingresar la solicitud de tu préstamo. Por tu seguridad, volveremos al inicio.',
      buttonLabel: 'Volver al inicio',
    },
  ],
  [
    'FTD',
    {
      imageUrl: {
        url: 'assets/img/errors/error__info-not-loaded.svg',
        altUrl: 'Information not loaded icon/illustration',
      },
      errorTitle: '¡Oh, no!',
      errorDescription:
        'Hubo un error y no pudimos abrir tu depósito a plazo fijo. Por tu seguridad, volveremos al inicio.',
      buttonLabel: 'Volver al inicio',
    },
  ],
  [
    'BIOMETRICS',
    {
      imageUrl: {
        url: 'assets/img/errors/error__info-not-loaded.svg',
        altUrl: 'Information not loaded icon/illustration',
      },
      errorTitle: '¡Oh, no!',
      errorDescription:
        'Hubo un error y no pudimos abrir tu cuenta. Por tu seguridad, volveremos al inicio.',
      buttonLabel: 'Volver al inicio',
    },
  ]
]);
